// extracted by mini-css-extract-plugin
export var container = "_mv-0";
export var dotAnimation = "_mv-2";
export var dotsLoading = "_mv-1";